import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=2bada82f&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=ts"
export * from "./AdminView.vue?vue&type=script&lang=ts"
import style0 from "./AdminView.vue?vue&type=style&index=0&id=2bada82f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bada82f",
  null
  
)

export default component.exports